// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled, { css } from 'styled-components';
import { Button } from 'antd';

export const ButtonWrapper = styled(Button)`
  margin-right: ${props => props.mr}px;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  color: ${props => props.theme.color[props.color]};
  font-size: ${({ theme }) => theme.fontSize.base};
  border-radius: ${props => props.theme.borderRadius[props.radius]};
  border: ${props =>
    props.gradient ? '0' : `1px solid ${props.theme.color.blue}`};
  box-shadow: none;

  ${props =>
    props.gradient
      ? css`
          background-image: ${props.theme.background[props.gradient]};

          &:hover {
            color: ${({ theme }) => theme.color.white};
            background-image: ${props =>
              props.gradient && props.theme.background[props.gradient]};
          }
        `
      : css`
          background-color: ${props => props.theme.color[props.background]};

          &:hover {
            color: ${({ theme }) => theme.color.blue};
            background-color: ${props => props.theme.color[props.background]};
            border-color: ${props => props.theme.color[props.color]};
          }
        `}

  &:focus {
    color: ${({ theme }) => theme.color.white};
    background-color: ${props => props.theme.color[props.color]};
    border-color: ${props => props.theme.color[props.color]};
    background-image: ${props =>
      props.gradient && props.theme.background[props.gradient]};
  }

  &:disabled {
    &,
    &:hover {
      background: ${({ theme }) => theme.color.grey1};
      color: ${({ theme }) => theme.color.grey2};
      border: 0;
    }
  }
`;
